import React, {Component, PropTypes} from 'react';
import {Link} from "react-router";
import FormInput from 'CONFIG/component/form/formInput'
import {ellaUrl} from '../../../path.config'
import Tip from 'COMPONENT/tip'
import {resultTip, language, errorShow} from 'UTIL/common'
import ellaService from 'SERVICES/purifier/ella/ellaService'
export default class AdministratorsAdd extends Component {
    constructor(props) {
        super(props);
        this.btnSubmit = this.btnSubmit.bind(this);
        this.state = {
            roleList: [],
            userType: [],
            extendsValue: [],
            url: ellaUrl
        };
    }
    componentDidMount() {
        var scrollFunc=function(e){
            e=e || window.event;
            if(e.wheelDelta){//IE/Opera/Chrome
                $("#laydate_box").hide()
            }else if(e.detail){//Firefox
                $("#laydate_box").hide()
            }
        }
        /*注册事件*/
        if(document.addEventListener){
            document.addEventListener('DOMMouseScroll',scrollFunc,false);
        }
        window.onmousewheel=document.onmousewheel=scrollFunc;
        ellaService.addUser().then(data => {
            if (data.data != null) {
                var nodeVos = JSON.parse(data.data.nodeVos);
                var userType = data.data.userTypeList;
                this.setState({
                    map: data.data,
                    roleList: data.data.roleList,
                    userType: userType,
                })
            }
        })
    }

    onchange() {
        var typeId = $("#userTypeId").val();
        if (typeId == 2) {
            $("#org").hide();
        } else {
            $("#org").show();
        }
        this.fetchExtendsValue(typeId);
    }

    btnSubmit(event) {
        event.preventDefault();
        var id = this.state.id;
        var remark = $("#remark").val();

        var loginName = $("#loginName").val();
        var realName = $("#realName").val();
        var telephone = $("#telephone").val();
        var email = $("#email").val();
        var address = $("#address").val();
        var userTypeId = 2;
        var chk_value = [];
        $('input[id="roleType"]:checked').each(function () {
            chk_value.push($(this).val());
        });
        var data = {
            id: id,
            loginName: loginName,
            realName: realName,
            telephone: telephone,
            email: email,
            address: address,
            roles: chk_value.toString(),
            userTypeId: 2,
        };
        var errorMessage = '';
        var ids = ['loginName', 'realName', 'telephone', 'email', 'address'];
        for (let i in ids) {
            if (data[ids[i]] == '') {
                errorMessage = '信息未填写！';
                errorShow(ids[i], errorMessage);
            }
        }
        if (errorMessage == '') {
            var userBody = JSON.stringify(data);
            ellaService.saveUser({userBody}).then(data => {
                resultTip(data, "/ella/user/user/administratorsList");
            })
        }

    }
    //多选框
    changeCheckbox(ids, fileDom) {
        var str = "name='checkbox" + ids + "'";
        var aa = "";
        $("input[" + str + "]:checkbox:checked").each(function () {
            aa += "," + $(this).val()
            console.log(aa);
        })
        $("#" + ids).val(aa + ",");
    }

    render() {
        const _this = this;
        //
        var selectrole = this.state.selectRole;
        const roleList = this.state.roleList.map(function (str, index) {
            var div = <div className="col-xs-3"><input className="input-hidden" id="roleType" value={str.id}
                                                       type="checkbox"></input>
                <span className="checkbox-body"></span>
                <span className="checkbox-text">{str.roleName}</span></div>;
            if (selectrole != null && selectrole.indexOf(str.id) != -1)
                div = <div className="col-xs-3"><input className="input-hidden" id="roleType" value={str.id}
                                                       type="checkbox" checked></input>
                    <span className="checkbox-body"></span>
                    <span className="checkbox-text">{str.roleName}</span></div>;

            return div;
        });
        //用户类型
        const userType = this.state.userType.map(function (str, index) {
            return <option value={str.id}>{str.name}</option>
        })

        return (
            <div >
                <section className="content-header ">
                    <h1> {language()['userManage']}
                        <small>{language()['managersAdd']}</small>
                    </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-plus-circle"></i>
                            <h3 className="box-title">{language()['managersAdd']}</h3>
                        </div>
                        <div className="box-body">
                            <Tip ids=""/>
                            <form id="micaFrom" className="form-horizontal">
                                <FormInput name="loginName" id="loginName"/>
                                <FormInput name="realName" id="realName"/>
                                <FormInput name="telephone" id="telephone"/>
                                <FormInput name="email" id="email"/>
                                <FormInput name="address" id="address"/>
                                <div className="row form-group">
                                    <label
                                        className="multi-label control-label col-xs-2">{language()['userType']}</label>
                                    <div className="col-xs-3">
                                        <select className="form-control" id="userTypeId"
                                                onChange={this.onchange.bind(this)}>
                                            <option value={2}>{language()['managers']}</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="row form-group">
                                    <label className="multi-label control-label col-xs-2">{language()['selectRole']}</label>
                                    <div className="col-xs-10" style={{marginBottom: "15px"}}>
                                        {roleList}
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="box-footer">
                            <div className="col-xs-2"></div>
                            <div className="col-xs-1 text-center">
                                <a className="btn btn-success" onClick={this.btnSubmit}>{language()['submit']}</a>
                            </div>
                            <div className="col-xs-1 text-center">
                                <Link to="/ella/user/user/administratorsList" className="btn btn-default btn-md">
                                    {language()['return']}
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/user/user/administratorsAdd.js